// extracted by mini-css-extract-plugin
export default {"productType":"ArticlesTicketType_productType__64j1u","icon":"ArticlesTicketType_icon__cbLhL","productTypeLabel":"ArticlesTicketType_productTypeLabel__i7Arz"};